let custmId;
let subsPackage;
let isSubscripbed;
let currentSubscription;
// Gift subscription members use the backend's gift API (set in layout/theme.liquid only
// for customers tagged gift_member); everyone else keeps the subscriber API.
let baseurl = window.SC_GIFT_API_BASE || "https://shopify.scentclub.ca";
let rooturl = "https://scentclub.ca";
let productSerialToReplaceWith = "";
let tokenIs = "";
let redirectTo = false;
let isASubscribedUser = false;
let getGlobalUrl = "";
let getGlobalUrlSrc = "";
let getGlobalUrlSplit = "";
let getGlobalUrlSplitFirst = "";



setTimeout(() => {

  getGlobalUrl = document.querySelector(".globalimglink img");
  // .globalimglink exists nowhere in the theme, so this was always null and threw on every page.
  // Returning early leaves the globals exactly as they were after the throw (empty strings).
  if (!getGlobalUrl) return;
  getGlobalUrlSrc = getGlobalUrl.src;

  getGlobalUrlSplit = getGlobalUrlSrc.split('files');
  getGlobalUrlSplitFirst = getGlobalUrlSplit.shift();
}, 3000);


// The last calendar this page fetched (every page fetches it shortly after loading).
let lastCalendar = null;

//Subscription check
const subCheck = (token) => {
  tokenIs = token;
  console.log("INSIDE SUBCHECK", token)
  // custmId = customerId;
  return fetch(
    `${baseurl}/api/customer/products`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${token}`
      }
    }
  ).then((res) => res.json().then((body) => {
      // A 401 also returns JSON ({"message":"Unauthenticated."}), so only a successful
      // response may mark the visitor as subscribed. Callers still get the parsed body.
      if (res.ok) {
        isASubscribedUser = true;
        sessionStorage.setItem("subscriptionStatus", true);
        // Kept so the calendar drawer can open already filled (see renderSideCart).
        lastCalendar = body;
      }
      return body
    }))
};

//Applying delete functions
const applyDelete = () => {
  setTimeout(() => {
    //Activating all products popup on account page
    [...document.querySelectorAll(".sub__item__icon_change")].map(i => {
      i.addEventListener("click", (e) => {
        // console.log(e.target);
        //document.querySelector(".acc__prod-popup").classList.add("active");
        handleProductChange(e.target);
      })
    });

    //Activating delete function
    [...document.querySelectorAll(".sub__item__icon_reset")].map(i => {
      i.addEventListener("click", (e) => {
        //document.querySelector(".acc__prod-popup").classList.add("active");
        handleResetToDefault(i);
      })
    });
  }, 2000);
}



//if subscriber -> show products accoutn page
const renderProducts = async (res) => {
  document.querySelector(".holder").style.display = "none";
  document.querySelector(".sub__items").innerHTML = "";
  document.querySelector(".sub__items").style.display = "none";
  if (res == "1x") {
    document.querySelector(".sub__items").classList.add("showing_1x");
  }

  res.products.map((parentItem) => {
    let itemColumn = document.createElement("div");
    itemColumn.setAttribute("data-currmonth", parentItem[0].month);
    itemColumn.classList.add("sub__item__column");
    parentItem.map((item, index) => {
      if (!item.fulfilled) {
        let itemProduct = item.product;

        if (itemProduct && itemProduct !== 'null' && itemProduct !== 'undefined') {
          let excPrice = (parseFloat(itemProduct.variants[0].price) - 19.95) - 3;
          let exclusiveHtml = `<div class="sub__item__charge"> +C$${excPrice.toFixed(2)}</div>`;

          let deleteHTML = `
          <div
          class="sub__item__icon sub__item__icon_reset"
          data-id="${item.shopify_product_id}"
          data-month="${item.month}"
          data-key="${item.key}"
          data-serial="${item.id}"
          data-delid="${item.key}"
          >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
          </div>
        `;
          let showDelete = (itemProduct.handle == 'perfume-of-the-month' ? false : true);

          let isExclusive = itemProduct.tags.includes("exclusive") || itemProduct.tags.includes("Exclusive") || itemProduct.tags.includes("EXCLUSIVE");
          let newElement = document.createElement("div");
          newElement.classList.add("sub__item");
          newElement.setAttribute("data-id", `${item.shopify_product_id}`);
          newElement.setAttribute("data-handle", `${item.product_handle}`);
          newElement.setAttribute("data-serial", item.id);
          newElement.setAttribute("data-month", item.month);
          newElement.setAttribute("data-key", item.key);

          // <i class="fa-solid fa-arrows-up-down-left-right"></i>
          // <div class="sub__item__icon sub__item__icon_move" data-delid="${index}">
          //   <box-icon name='move'></box-icon>
          // </div>

          newElement.innerHTML = `

        <div class="sub__item__img">
          <div class="sub__item__img__item">
              <img src="${calImg(item.product.image.src)}" decoding="async">
          </div>
          ${(isExclusive && (excPrice > 0)) ? exclusiveHtml : ""}
         </div>

        <div class="sub__item__content">
        <div class="sub__item__top">
          <div class="sub__item__vendor">${itemProduct.vendor}</div>
          <div class="sub__item__title">${itemProduct.title}</div>

          </div>
          <div class="sub__item__info">
          <div class="sub__item__day">${item.month}</div>
          <div class="sub__item__btm-btns">
          <div
          class="sub__item__icon sub__item__icon_change"
          data-id="${item.shopify_product_id}"
          data-month="${item.month}"
          data-key="${item.key}"
          data-serial="${item.id}"
          data-delid="${item.key}"
          >
            Update
          </div>

          ${showDelete ? deleteHTML : ""}

          </div>
        </div>
        </div>
        `;

          itemColumn.appendChild(newElement);
        }
      }
    });
    document.querySelector(".sub__items").appendChild(itemColumn);

    document.querySelector(".sub__items").style.display = "block";
  });


  applyDelete();
};


// Product images come back at their original size (often 2000 px PNGs); the calendar shows them at about
// 120-160 px, so ask Shopify's image CDN for a small copy.
const calImg = (src) => src ? src + (src.includes("?") ? "&" : "?") + "width=320" : "";

//Sidecart
// The drawer opens at once: filled from the calendar this page already fetched when there is one, otherwise
// with a loading line. A fresh copy (which includes the pick just added) replaces it as soon as it arrives.
const renderSideCart = async (token) => {
  const sdItems = document.querySelector(".sd__items");
  if (lastCalendar && lastCalendar.products) {
    fillSideCart(lastCalendar);
  } else {
    sdItems.innerHTML = '<p class="sd__loading" style="padding:16px;opacity:.7">Loading your calendar…</p>';
  }
  document.querySelector("body").classList.add("show_sd");

  fetch(
    `${baseurl}/api/customer/products`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${token}`
      }
    })
    .then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    })
    .then(res => {
      lastCalendar = res;
      fillSideCart(res);
    })
    .catch(() => {
      // Keep the copy already shown; only an empty drawer needs the message.
      if (sdItems.querySelector(".sd__loading")) {
        sdItems.innerHTML = '<p class="sd__loading" style="padding:16px">Couldn\'t load your calendar. Close this and try again.</p>';
      }
    })
};

const fillSideCart = (res) => {
      document.querySelector(".sd__items").innerHTML = "";
      res.products.map((parentItem) => {
        let itemColumn = document.createElement("div");
        itemColumn.setAttribute("data-currmonth", parentItem[0].month);
        itemColumn.classList.add("sub__item__column");
        parentItem.map((item, index) => {
          if (!item.fulfilled) {
            let itemProduct = item.product;

            if (itemProduct && itemProduct !== 'null' && itemProduct !== 'undefined') {
              let excPrice = (parseFloat(itemProduct.variants[0].price) - 19.95) - 3;
              let exclusiveHtml = `<div class="sub__item__charge"> +C$${excPrice.toFixed(2)}</div>`;

              let isExclusive = itemProduct.tags.includes("exclusive") || itemProduct.tags.includes("Exclusive") || itemProduct.tags.includes("EXCLUSIVE");
              let newElement = document.createElement("div");
              newElement.classList.add("sub__item");
              newElement.setAttribute("data-id", `${item.shopify_product_id}`);
              newElement.setAttribute("data-handle", `${item.product_handle}`);
              newElement.setAttribute("data-serial", item.id);
              newElement.setAttribute("data-month", item.month);
              newElement.setAttribute("data-key", item.key);

              newElement.innerHTML = `

        <div class="sub__item__img">
          <div class="sub__item__img__item">
              <img src="${calImg(item.product.image.src)}" decoding="async">
          </div>
          ${(isExclusive && (excPrice > 0)) ? exclusiveHtml : ""}
         </div>

        <div class="sub__item__content">
        <div class="sub__item__top">
          <div class="sub__item__vendor">${itemProduct.vendor}</div>
          <div class="sub__item__title">${itemProduct.title}</div>

          </div>
          <div class="sub__item__info">
            <div class="sub__item__day">${item.month}</div>
          </div>
        </div>
        `;

              itemColumn.appendChild(newElement);
            }
          }
        });
        document.querySelector(".sd__items").appendChild(itemColumn);

      })

  // if (res == "1x") {
  //   document.querySelector(".sub__items").classList.add("showing_1x");
  // }



};


// The account page loads without the scent picker (366 cards, about 8 MB). The first Update fetches it through
// Shopify's section rendering into #sc-picker-slot, runs its scripts and starts its carousels, the same set-up
// the page used to do on load. Pages that still render the picker inline skip all of this.
let pickerLoading = null;
const loadPicker = () => {
  if (document.querySelector(".acc-p__tabs")) return Promise.resolve();
  const slot = document.getElementById("sc-picker-slot");
  if (!slot) return Promise.resolve();
  if (!pickerLoading) {
    slot.innerHTML = '<p class="sc-picker-loading" style="padding:24px;text-align:center">Loading scents…</p>';
    pickerLoading = fetch(`${window.location.pathname}?section_id=section__acc_tabs`, { credentials: "same-origin" })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.text();
      })
      .then((html) => {
        slot.innerHTML = html;
        // Scripts inserted as HTML do not run; recreate each one so it does, in order.
        slot.querySelectorAll("script").forEach((old) => {
          const s = document.createElement("script");
          Array.prototype.forEach.call(old.attributes, (a) => s.setAttribute(a.name, a.value));
          s.text = old.textContent;
          old.replaceWith(s);
        });
        const section = slot.querySelector('[data-section-type="producttabs"]');
        if (section && window.theme && theme.Producttabs) {
          try { new theme.Producttabs(section); } catch (e) { console.error("picker carousel:", e); }
        }
      })
      .catch((err) => {
        pickerLoading = null;
        slot.innerHTML = '<p class="sc-picker-loading" style="padding:24px;text-align:center">Couldn\'t load the scents. Please press Update again.</p>';
        throw err;
      });
  }
  return pickerLoading;
};

//Opening the popup to select replaceble product
const handleProductChange = (data) => {
  productSerialToReplaceWith = data.dataset.serial;
  loadPicker()
    .then(() => {
      const picker = document.querySelector(".acc-p__tabs");
      if (!picker) return;
      picker.style.display = "block";
      // Carousels set up while hidden need their sizes measured once visible.
      if (window.jQuery) { jQuery(picker).find(".slick-initialized").slick("setPosition"); }
      document.querySelector(".productlists-wrapper").scrollIntoView({ behavior: 'smooth' });
    })
    .catch((err) => console.error("picker:", err));
}

//Select a replaceble product from the list
const handleReplaceSelect = (thisProd) => {

  document.querySelector(".acc-p__tabs").style.display = "none";
  document.querySelector(".sub__calender").scrollIntoView({ behavior: 'smooth' });
  document.querySelector(".holder").style.display = "block";

  const data = {
    id: productSerialToReplaceWith,
    shopify_product_id: thisProd.dataset.id,
    product_handle: thisProd.dataset.handle
  };

  fetch(
    `${baseurl}/api/customer/products/update`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${thisProd.dataset.token}`
      },
      body: JSON.stringify(data),
    }
  )
    .then(res => res.json())
    .then(res => {
      console.log("AFTER UPDATE", res);
      document.querySelector(".sub__items").style.display = "none";
      subCheck(tokenIs)
        .then(res => {
          renderProducts(res);
        })
    })

}

//HANDLING ADD TO CART
const handleATC = (thisProd, isAccount, token, title) => {
  console.log("TOKENNNNNNNNNNN:::", token);
  
  // Check if product has bundle_link metafield - if so, redirect instead of adding to cart
  const bundleLink = thisProd.getAttribute('data-bundle-link');
  if (bundleLink) {
    window.location.href = bundleLink;
    return;
  }
  
  if (isAccount && token != null && token != "") {
    // No separate subscription check first: the save itself is refused for non-subscribers
    // (the backend's "subscribed" middleware answers 404 with key 0), so one request does
    // both jobs. The old check loaded the whole calendar before every pick, about 0.7 s.
    tokenIs = token;
    const data = {
      product_id: thisProd.dataset.id,
      variant_id: thisProd.dataset.varid,
      product_handle: thisProd.dataset.handle,
    };
    const originalLabel = thisProd.innerHTML;
    thisProd.disabled = true;
    thisProd.innerHTML = "Adding…";

    fetch(
      `${baseurl}/api/customer/products`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data),
      }
    )
      .then((response) => response.json().catch(() => ({})).then((body) => {
        if (response.status == 404 && body.key == 0) {
          window.location.href = `${rooturl}/pages/subscribe-1`;
          return null;
        }
        // A failed save still answers with JSON, so "it parsed" is not "it saved".
        // Only a 2xx may show success. From 2026-09-22 to 2026-09-28 every save
        // returned 500 and customers were shown "Subscribed" anyway, so the pick
        // looked accepted and then silently never appeared in their calendar.
        if (!response.ok) {
          throw new Error(`Add to calendar failed (HTTP ${response.status})`);
        }
        return body;
      }))
      .then((body) => {
        if (body === null) return;
        isASubscribedUser = true;
        sessionStorage.setItem("subscriptionStatus", true);
        thisProd.classList.add("product-added-2cart");
        thisProd.innerHTML = "Subscribed";
        // The side panel loads after the button already says "Subscribed".
        renderSideCart(token);
      })

      .catch((error) => {
        console.error("Error:", error);
        // Say so at the point of action, then give the button back.
        thisProd.innerHTML = "Couldn't add — please try again";
        thisProd.disabled = false;
        setTimeout(() => { thisProd.innerHTML = originalLabel; }, 4000);
      });

  } else {
    redirectTo = true;
    document.querySelector("body").classList.add("show_sub_notice");
    // The dialog owns the countdown, the visible timer and every cancel path
    // (snippets/subscriotion-notice.liquid). Fall back to the bare timeout only if the
    // snippet somehow did not render, so this branch can never silently stop working.
    if (window.armSubNoticeRedirect) {
      window.armSubNoticeRedirect(`${rooturl}/pages/subscribe-1`, 10);
    } else {
      setTimeout(() => {
        if (redirectTo) {
          window.location.href = `${rooturl}/pages/subscribe-1`;
        }
      }, 10000);
    }
  }
};

//Handle btn show
const handleBtnClick = (id) => {
  console.log(`.prod__tab-${id}`);
  [...document.querySelectorAll(".prod__tab-cnt")].map(i => {
    i.classList.remove("active");
  });

  [...document.querySelectorAll(".prod__all-btns__item")].map(i => {
    i.classList.remove("active");
  });

  [...document.querySelectorAll(`.prod__tab-${id}`)].map(i => {
    i.classList.add("active");
  });

  //document.querySelector(`.prod__tab-${id}`).classList.add("active");
}

//Resetting to default product or DELETE ITEM
const handleResetToDefault = (indata) => {
  document.querySelector(".holder").style.display = "block";
  let data = {
    "product_id": indata.dataset.id,
    "key": indata.dataset.key,
    "date": indata.dataset.month
  }

  fetch(
    `${baseurl}/api/customer/products/delete`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${tokenIs}`
      },
      body: JSON.stringify(data),
    }
  )
    .then(res => res.json())
    .then(res => {
      console.log("after deleted", res)
      subCheck(tokenIs)
        .then(res => {
          console.log("RENDERING AFTER DELETE");
          renderProducts(res)
        })
    })

}

//Render cart notification
const renderNotification = (handle, title) => {
  let img = `<img src="${getGlobalUrlSplitFirst}files/${handle}.jpg">`;
  document.querySelector(".cn__item-title").innerHTML = title;
  document.querySelector(".cn__img").innerHTML = img;
  document.querySelector(".cn__inner").classList.add("active");

}


//Sidecart
const handleCartClick = (token) => {
  console.log("CART clicked");
  // No token tag means no subscription calendar yet, and the API could only answer 401.
  if (!token) {
    window.location.href = `${rooturl}/pages/subscribe-1`;
    return;
  }
  subCheck(token)
    .then(res => {
      // key 0 = no active subscription. A 401 (expired/invalid token) has no key at all, and
      // `undefined == 0` is false, so it used to fall through to the calendar branch below.
      if (!res || res.key === undefined || res.key == 0) {
        window.location.href = `${rooturl}/pages/subscribe-1`;
      } else {
        // renderSideCart fetches the calendar itself and needs the token. It used to be handed
        // the response object, which went out as "Bearer [object Object]", got a 401, and left
        // the drawer empty for every subscriber.
        renderSideCart(token);
        document.querySelector("body").classList.add("show_sd");
      }
    })
}

//Stop popup redirect. The dialog defines window.handleRedirectStop and is the only thing
//that can clear its countdown interval, so delegate to it when it is present. This `const`
//lives in the global declarative scope, not on window, so the two never recurse.
const handleRedirectStop = () => {
  redirectTo = false;
  if (window.handleRedirectStop) {
    window.handleRedirectStop();
    return;
  }
  document.querySelector("body").classList.remove("show_sub_notice");
}



setTimeout(() => {
  //Closing sidecart from view
  document.querySelector(".sd__overlay").addEventListener("click", () => {
    document.querySelector("body").classList.remove("show_sd");
  });
  document.querySelector(".sd__close").addEventListener("click", () => {
    document.querySelector("body").classList.remove("show_sd");
  });
  //Closing notification
  document.querySelector(".cn__close").addEventListener("click", () => {
    console.log("revmoing notification");
    document.querySelector(".cn__inner").classList.remove("active");
  });

  //Activating all products popup on account page
  [...document.querySelectorAll(".sub__item__icon_change")].map(i => {
    i.addEventListener("click", (e) => {
      console.log(e.target);
      //document.querySelector(".acc__prod-popup").classList.add("active");
      handleProductChange(e.target);
    })
  });

  //Activating delete function
  [...document.querySelectorAll(".sub__item__icon_reset")].map(i => {
    i.addEventListener("click", (e) => {
      console.log(i);
      //document.querySelector(".acc__prod-popup").classList.add("active");
      handleResetToDefault(i);
    })
  });
}, 10000);




// Capture a section as a image
// html2canvas(document.querySelector("#capture")).then(canvas => {
//   document.body.appendChild(canvas)
// });


// Handle product bundle link redirects
// This intercepts clicks on product links and redirects if the product has a bundle_link metafield
(function() {
  // Function to handle product link clicks
  function handleProductLinkClick(e) {
    const link = e.currentTarget;
    
    // Check if link has data-bundle-link attribute (added by Liquid)
    const bundleLink = link.getAttribute('data-bundle-link');
    
    if (bundleLink) {
      e.preventDefault();
      window.location.href = bundleLink;
      return;
    }
  }

  // Add click listeners to all product links
  function attachProductLinkListeners() {
    // Select all product links that have bundle link data attribute or are product links
    const productLinks = document.querySelectorAll(
      'a[href*="/products/"]:not([data-bundle-handled])'
    );
    
    productLinks.forEach(link => {
      link.setAttribute('data-bundle-handled', 'true');
      link.addEventListener('click', handleProductLinkClick);
    });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachProductLinkListeners);
  } else {
    attachProductLinkListeners();
  }

  // Re-attach listeners for dynamically loaded content
  if (document.body) {
    const observer = new MutationObserver(() => {
      attachProductLinkListeners();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();